module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//21.jpg?224cd15a60c4279ee5c9446f1db879ba";